import React from "react";

import Loading from "../Loading";
import Media from "../Media";
import { API_KEY } from "../../utils/constants";
import useFetch from "../../hooks/useFetch";

const Photos = ({ id }) => {
  const url = `movie/${id}/images?api_key=${API_KEY}&language=en-US&include_image_language=null`;
  const { data, isLoading } = useFetch(url);

  return (
    <Loading loading={isLoading} isHalf>
      <Media data={data?.backdrops} isPhotos />
    </Loading>
  );
};

export default Photos;
